import 'whatwg-fetch'; // fetch polyfill

import cookie from 'cookie';

import {startRequest} from 'common/automationUtils';

export default class BaseApi {
  constructor() {
    const cookieMap = cookie.parse(document.cookie);
    this.defaultParams = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Token ${cookieMap.transloc_authn_cookie}`,
      },
    };
  }

  fetch(method, endpoint, data) {
    const url = `${this.baseUrl}${endpoint}`;
    const request = startRequest(url);
    return fetch(url, {
      method,
      body: data ? JSON.stringify(data) : null,
      ...this.defaultParams,
    }).then((...args) => {
      request.end();
      return Promise.resolve(...args);
    }, (...args) => {
      request.end();
      return Promise.reject(...args);
    });
  }
}



// WEBPACK FOOTER //
// ./src/common/api/base.js